module.exports = __webpack_public_path__ + "static/img/financial-service.933f4a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/imgs/my/financial-service.png
// module id = Tv7O
// module chunks = 1